const imports = require("../../../lib");
module.exports = imports.google.rpc;

const grpc = {};
grpc.web = require("grpc-web");
